(function(){
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  function lock(v){document.documentElement.style.overflow=v?'hidden':'';document.body.style.overflow=v?'hidden':'';}
  function openDrawer(id){const d=$(id),o=$('.wlts-overlay');if(!d)return;d.classList.add('is-open');d.setAttribute('aria-hidden','false');if(o)o.classList.add('is-open');lock(true);}
  function closeDrawers(){ $$('.wlts-drawer').forEach(d=>{d.classList.remove('is-open');d.setAttribute('aria-hidden','true')});const o=$('.wlts-overlay');if(o)o.classList.remove('is-open');lock(false); }
  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-open-drawer]'); if(open){e.preventDefault();openDrawer(open.dataset.openDrawer);}
    if(e.target.closest('[data-close-drawers]')){e.preventDefault();closeDrawers();}
    const acc=e.target.closest('[data-accordion-button]');if(acc){e.preventDefault();const isOpen=acc.closest('.wlts-accordion').classList.toggle('is-open');acc.setAttribute('aria-expanded',String(isOpen));}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawers();});

  async function cartJSON(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});return r.json();}
function money(cents){
  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }
    ).format(cents / 100);
  } catch(e) {
    const amount = cents / 100;
    return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
  }
}
  function renderCart(cart){$$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);const items=$('[data-cart-items]'),empty=$('[data-cart-empty]'),sub=$('[data-cart-subtotal]');if(!items)return;items.innerHTML='';if(!cart.items.length){if(empty)empty.hidden=false}else{if(empty)empty.hidden=true;cart.items.forEach(i=>{const row=document.createElement('div');row.className='wlts-cart-line';row.innerHTML=`<a href="${i.url}"><img loading="eager" src="${i.image||''}" alt=""></a><div><a class="wlts-cart-line__title wlts-pixel wlts-uppercase" href="${i.url}">${i.product_title}</a><div class="wlts-cart-line__meta wlts-pixel">${i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:''} × ${i.quantity}</div><div class="wlts-cart-line__price wlts-pixel"><span>${money(i.final_line_price)}</span><span>× ${i.quantity}</span></div><div class="wlts-cart-line__actions"><button data-cart-change="${i.key}" data-cart-qty="${i.quantity+1}">ADD</button><button data-cart-change="${i.key}" data-cart-qty="0">REMOVE</button></div></div>`;items.appendChild(row);});}if(sub)sub.textContent=money(cart.total_price)}
  let walletRequest=0;
  async function refreshWallets(cart){
    const current=$('[data-cart-wallets]');
    if(!current)return;
    const request=++walletRequest;
    current.hidden=true;
    if(!cart.item_count)return;
    const sectionId=$('#WLTS-CartDrawer')?.dataset.cartSectionId;
    try{
      const url=new URL(location.href);url.searchParams.set('section_id',sectionId);
      const response=await fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)throw new Error('Wallet refresh failed');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      if(request!==walletRequest)return;
      const fresh=doc.querySelector('[data-cart-wallets]');
      if(fresh)current.replaceWith(fresh);
    }catch(error){console.warn('WLTS wallet checkout:',error);}
  }
  async function refreshCart(){try{const cart=await cartJSON();renderCart(cart);await refreshWallets(cart)}catch(e){console.warn(e)}}
  document.addEventListener('click',async e=>{const b=e.target.closest('[data-cart-change]');if(!b)return;e.preventDefault();b.disabled=true;try{const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.dataset.cartChange,quantity:Number(b.dataset.cartQty)})});const cart=await r.json();renderCart(cart);await refreshWallets(cart)}finally{b.disabled=false}});
  document.addEventListener('submit',async e=>{const form=e.target.closest('[data-product-form]');if(!form)return;e.preventDefault();const btn=form.querySelector('[type=submit]');if(btn.disabled||form.dataset.submitting)return;form.dataset.submitting='true';btn.disabled=true;const old=btn.textContent;btn.textContent='ADDING…';try{const fd=new FormData(form);const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});if(!r.ok)throw new Error((await r.json()).description||'Unable to add');await refreshCart();openDrawer('#WLTS-CartDrawer')}catch(err){alert(err.message)}finally{delete form.dataset.submitting;btn.disabled=false;btn.textContent=old}});
  refreshCart();

  $$('[data-product-section]').forEach(section=>{
    const variants=JSON.parse(section.querySelector('[data-variants-json]')?.textContent||'[]');const form=section.querySelector('[data-product-form]');if(!form)return;
    form.addEventListener('change',()=>{const vals=$$('input[type=radio]:checked',form).map(i=>i.value);const v=variants.find(v=>v.options.every((x,idx)=>x===vals[idx]));if(!v)return;form.querySelector('[name=id]').value=v.id;const p=section.querySelector('[data-product-price]');if(p)p.textContent=money(v.price);const b=form.querySelector('[type=submit]');b.disabled=!v.available;b.textContent=v.available?(b.dataset.addText||'ADD TO CART →'):(b.dataset.soldText||'SOLD OUT');if(history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}})
  });

  $$('[data-recommendations-url]').forEach(async el=>{
    try{
      const html=await fetch(el.dataset.recommendationsUrl,{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(r=>r.text());
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('[data-product-recommendations]');
      if(fresh){
        const current=el.closest('[data-product-recommendations]');
        if(current) current.replaceWith(fresh); else el.replaceWith(fresh);
      }
    }catch(e){console.warn('WLTS recommendations:',e)}
  });

  function positionCartFab(){
    const fab=$('.wlts-cart-fab'), footer=$('[data-wlts-footer]');
    if(!fab)return;
    let bottom=22;
    if(footer){
      const r=footer.getBoundingClientRect();
      const overlap=Math.max(0,window.innerHeight-r.top);
      if(overlap>0) bottom=overlap+14;
    }
    document.documentElement.style.setProperty('--wlts-cart-fab-bottom',bottom+'px');
  }
  positionCartFab();
  window.addEventListener('scroll',positionCartFab,{passive:true});
  window.addEventListener('resize',positionCartFab);
})();

/* Product media drag + swipe + pagination dots */
(function () {
  const sliders = [...document.querySelectorAll('.wlts-product-media')];

  sliders.forEach(slider => {
    const wrap = slider.closest('.wlts-product-media-wrap');
    const slides = [...slider.querySelectorAll('[data-media-slide]')];
    const dots = wrap
      ? [...wrap.querySelectorAll('[data-media-dot]')]
      : [];

    if (slides.length < 2) return;

    let dragging = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    let moved = false;
    let horizontalDrag = false;
    let raf = 0;

    function getCurrentIndex() {
      const width = slider.clientWidth || 1;

      return Math.max(
        0,
        Math.min(
          slides.length - 1,
          Math.round(slider.scrollLeft / width)
        )
      );
    }

    function setSliderHeight(index) {
      if (window.innerWidth > 991) {
        slider.style.height = '';
        return;
      }

      const slide = slides[index];
      if (!slide) return;

      const media = slide.querySelector(
        '.wlts-product-media__asset, img, video'
      );

      if (!media) {
        const slideHeight = slide.scrollHeight;

        if (slideHeight > 0) {
          slider.style.height = `${Math.ceil(slideHeight)}px`;
        }

        return;
      }

      const update = () => {
        /*
         * Images are width:100% / height:auto.
         * Therefore their rendered height is exactly the height
         * we want the horizontal carousel to use.
         */
        const height = media.getBoundingClientRect().height;

        if (height > 0) {
          slider.style.height = `${Math.ceil(height)}px`;
        }
      };

      update();

      if (media.tagName === 'IMG' && !media.complete) {
        media.addEventListener('load', update, { once: true });
      }

      if (media.tagName === 'VIDEO' && media.readyState < 1) {
        media.addEventListener('loadedmetadata', update, { once: true });
      }
    }

    function setActive() {
      if (window.innerWidth > 991) {
        slider.style.height = '';
        return;
      }

      const index = getCurrentIndex();

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      setSliderHeight(index);
    }

    /*
     * Prevent the browser's native image dragging from fighting
     * with our mouse drag in Shopify's mobile theme preview.
     */
    slider.querySelectorAll('img').forEach(img => {
      img.draggable = false;

      img.addEventListener('dragstart', e => {
        e.preventDefault();
      });
    });

    slider.addEventListener(
      'dragstart',
      e => {
        e.preventDefault();
      },
      true
    );

    /*
     * Keep pagination dots synced with horizontal scrolling.
     */
    slider.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(raf);

        raf = requestAnimationFrame(() => {
          setActive();
        });
      },
      { passive: true }
    );

    /*
     * Pagination dot clicks.
     */
    dots.forEach(dot => {
      dot.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const index = Number(dot.dataset.mediaDot || 0);

        /*
         * Change the canvas height immediately before scrolling
         * to the requested slide.
         */
        setSliderHeight(index);

        dots.forEach((otherDot, i) => {
          otherDot.classList.toggle('is-active', i === index);
        });

        slider.scrollTo({
          left: index * slider.clientWidth,
          behavior: 'smooth'
        });
      });
    });

    /*
     * Begin mouse/touch drag.
     */
    slider.addEventListener('pointerdown', e => {
      if (window.innerWidth > 991) return;

      /*
       * Don't hijack controls/links.
       */
      if (e.target.closest('button, a, input, video')) return;

      /*
       * Mouse must use left click.
       * Touch and pen continue normally.
       */
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      dragging = true;
      pointerId = e.pointerId;

      startX = e.clientX;
      startY = e.clientY;
      startScroll = slider.scrollLeft;

      moved = false;
      horizontalDrag = false;

      try {
        slider.setPointerCapture(pointerId);
      } catch (_) {}
    });

    /*
     * Horizontal dragging.
     * Vertical gestures remain available for normal page scrolling.
     */
    slider.addEventListener('pointermove', e => {
      if (!dragging) return;
      if (e.pointerId !== pointerId) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!horizontalDrag) {
        /*
         * Ignore tiny movements.
         */
        if (Math.abs(dx) < 4 && Math.abs(dy) < 4) {
          return;
        }

        /*
         * If the gesture is primarily vertical, abandon the
         * carousel drag and allow page scrolling.
         */
        if (Math.abs(dy) > Math.abs(dx)) {
          dragging = false;

          try {
            slider.releasePointerCapture(pointerId);
          } catch (_) {}

          pointerId = null;
          return;
        }

        horizontalDrag = true;
        moved = true;

        slider.classList.add('is-dragging');
      }

      slider.scrollLeft = startScroll - dx;

      e.preventDefault();
    });

    function endDrag(e) {
      if (!dragging) return;

      if (
        pointerId !== null &&
        typeof e.pointerId === 'number' &&
        e.pointerId !== pointerId
      ) {
        return;
      }

      dragging = false;

      slider.classList.remove('is-dragging');

      try {
        if (pointerId !== null) {
          slider.releasePointerCapture(pointerId);
        }
      } catch (_) {}

      pointerId = null;

      if (horizontalDrag) {
        const width = slider.clientWidth || 1;
        const index = getCurrentIndex();

        /*
         * Resize to the destination slide before snapping there.
         */
        setSliderHeight(index);

        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });

        slider.scrollTo({
          left: index * width,
          behavior: 'smooth'
        });
      }

      horizontalDrag = false;

      setTimeout(() => {
        moved = false;
      }, 0);
    }

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);

    /*
     * Do NOT use pointerleave here.
     * Shopify's theme-editor iframe can trigger pointerleave
     * during a perfectly valid mouse drag.
     */

    slider.addEventListener(
      'click',
      e => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    /*
     * Image heights may not be available on the first JS tick,
     * while Shopify images are still downloading.
     */
    slides.forEach(slide => {
      const media = slide.querySelector(
        '.wlts-product-media__asset, img, video'
      );

      if (!media) return;

      if (media.tagName === 'IMG') {
        if (media.complete) {
          setActive();
        } else {
          media.addEventListener('load', setActive, { once: true });
        }
      }

      if (media.tagName === 'VIDEO') {
        media.addEventListener('loadedmetadata', setActive);
      }
    });

    window.addEventListener('resize', setActive);

    requestAnimationFrame(() => {
      setActive();
    });
  });
})();





/* Size guide IN / CM toggle */
(function () {
  const toggles = [...document.querySelectorAll('[data-size-unit-toggle]')];

  toggles.forEach(toggle => {
    const accordion = toggle.closest('.wlts-accordion');
    if (!accordion) return;

    const table = accordion.querySelector('[data-size-table]');
    if (!table) return;

    const buttons = [...toggle.querySelectorAll('[data-size-unit]')];

    /*
     * Measurements live in every column except the first SIZE column.
     * Save the original metafield text once so switching back to IN
     * restores it exactly.
     */
    const cells = [
      ...table.querySelectorAll('tbody tr td:not(:first-child)')
    ];

    cells.forEach(cell => {
      cell.dataset.inchesOriginal = cell.textContent.trim();
    });

    function setUnit(unit) {
      buttons.forEach(button => {
        const active = button.dataset.sizeUnit === unit;

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      cells.forEach(cell => {
        const original = cell.dataset.inchesOriginal || '';

        if (unit === 'in') {
          cell.textContent = original;
          return;
        }

        /*
         * Examples:
         * "18 in"  -> 45.7 cm
         * "7.5 in" -> 19.1 cm
         */
        const inches = parseFloat(original);

        if (Number.isNaN(inches)) {
          cell.textContent = original;
          return;
        }

        const cm = inches * 2.54;

        const formatted = Math.round(cm);

        cell.textContent = `${formatted} cm`;
      });
    }

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        setUnit(button.dataset.sizeUnit);
      });
    });

    setUnit('in');
  });
})();